import request from '@/utils/request'

export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

export function getUserPermissions() {
  return request({
    url: '/user/permissions',
    method: 'get'
  })
}

export function changePassword(data) {
  return request({
    url: '/user/changePassword',
    method: 'put',
    data
  })
}

export function resetPassword() {
  return request({
    url: '/user/resetPassword',
    method: 'put'
  })
}
